import { Link } from "react-router-dom";
import { ArrowLeft, Check, X } from "lucide-react";
import { packageLimits } from "@/lib/pricing";

export const TripHero = ({ trip }) => (
  <section className="relative flex min-h-[62vh] items-end overflow-hidden" data-testid="trip-hero">
    <img src={trip.image_url || "/images/hikers.jpg"} alt={trip.name} className="slow-zoom absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/60 to-black/40" />
    <div className="relative mx-auto w-full max-w-7xl px-5 pb-12 pt-32 sm:px-8">
      <Link to="/#trip" className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-white" data-testid="trip-back-link">
        <ArrowLeft className="h-4 w-4" /> Semua trip
      </Link>
      <p className="overline-label mt-8">{trip.location}</p>
      <h1 className="mt-4 font-display text-4xl font-light leading-[1.05] sm:text-5xl lg:text-7xl" data-testid="trip-title">
        {trip.mountain || trip.name}
      </h1>
      <div className="mt-6 flex flex-wrap items-center gap-3 text-sm text-neutral-300">
        {trip.elevation > 0 && <span className="font-mono">{trip.elevation.toLocaleString("id-ID")} mdpl</span>}
        <a href="#booking" className="btn-gold h-11" data-testid="trip-hero-book-btn">Pesan Sekarang</a>
      </div>
    </div>
  </section>
);

const Fact = ({ label, value }) => (
  <div className="border-l border-white/10 pl-4">
    <p className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">{label}</p>
    <p className="mt-1.5 text-sm text-neutral-100">{value}</p>
  </div>
);

const ItemList = ({ title, items, ok }) => (
  <div>
    <p className="overline-label">{title}</p>
    <ul className="mt-4 space-y-2.5">
      {items.map((item) => (
        <li key={item} className="flex items-start gap-3 text-sm text-neutral-300">
          {ok ? <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> : <X className="mt-0.5 h-4 w-4 shrink-0 text-neutral-600" />}
          {item}
        </li>
      ))}
    </ul>
  </div>
);

export const TripInfo = ({ trip, pkg }) => {
  const [low, high] = packageLimits(pkg);
  return (
    <div className="space-y-12" data-testid="trip-info">
      {trip.description && <p className="text-lg leading-relaxed text-neutral-300">{trip.description}</p>}
      <div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
        <Fact label="Paket" value={pkg.name} />
        <Fact label="Durasi" value={pkg.duration_label || `${pkg.duration_days} hari`} />
        <Fact label="Peserta" value={`${low}–${high} orang`} />
        {trip.meeting_point && <Fact label="Titik kumpul" value={trip.meeting_point} />}
      </div>
      {(pkg.includes.length > 0 || pkg.excludes.length > 0) && (
        <div className="grid gap-10 rounded-2xl border border-white/10 p-6 sm:grid-cols-2 sm:p-8" data-testid="trip-include-exclude">
          {pkg.includes.length > 0 && <ItemList title="Termasuk" items={pkg.includes} ok />}
          {pkg.excludes.length > 0 && <ItemList title="Tidak termasuk" items={pkg.excludes} />}
        </div>
      )}
      {trip.itinerary.length > 0 && (
        <div>
          <p className="overline-label">Rencana perjalanan</p>
          <ol className="mt-6 space-y-5 border-l border-white/10 pl-6">
            {trip.itinerary.map((step) => <li key={step} className="text-sm leading-relaxed text-neutral-300">{step}</li>)}
          </ol>
        </div>
      )}
    </div>
  );
};
